import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { Text } from '@atlaskit/primitives';
import { useAIAnswerContext } from '../../../../ai-answer-context';
import { onRecentWorkItemClick, onRecentWorkItemContextMenuClick } from '../../../../analytics';
import { descriptionHelper } from './description-helper';
import { RecentWorkItemBody, RecentWorkItemByline, RecentWorkItemContainer, RecentWorkItemDescription, RecentWorkItemIcon, RecentWorkItemLink, RecentWorkItemTitle, RecentWorkItemWrapper } from './styled';
export var RecentWorkItem = function RecentWorkItem(_ref) {
  var index = _ref.index,
    title = _ref.title,
    iconUrl = _ref.iconUrl,
    url = _ref.url,
    container = _ref.container,
    event = _ref.event,
    contributors = _ref.contributors,
    timestamp = _ref.timestamp,
    othersCount = _ref.othersCount;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage,
    formatDate = _useIntl.formatDate;
  var _useAIAnswerContext = useAIAnswerContext(),
    currentUserId = _useAIAnswerContext.userDetails.id,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent,
    commonAttributes = _useAIAnswerContext.commonAttributes,
    onNavigate = _useAIAnswerContext.onNavigate;
  var description = descriptionHelper({
    currentUserId: !!currentUserId ? currentUserId : '',
    event: event,
    contributors: contributors,
    othersCount: othersCount,
    formatMessage: formatMessage,
    formatDate: formatDate,
    timestamp: new Date(timestamp)
  });
  var onClick = useCallback(function (event) {
    onNavigate(event);
    fireAnalyticsEvent(onRecentWorkItemClick(_objectSpread({
      index: index,
      url: url
    }, commonAttributes)));
  }, [onNavigate, fireAnalyticsEvent, index, url, commonAttributes]);
  var onContextMenuClick = useCallback(function (event) {
    onNavigate(event);
    fireAnalyticsEvent(onRecentWorkItemContextMenuClick(_objectSpread({
      index: index,
      url: url
    }, commonAttributes)));
  }, [onNavigate, fireAnalyticsEvent, index, url, commonAttributes]);
  return /*#__PURE__*/React.createElement(RecentWorkItemLink, {
    href: url,
    onClick: onClick,
    onContextMenu: onContextMenuClick
  }, /*#__PURE__*/React.createElement(RecentWorkItemWrapper, null, /*#__PURE__*/React.createElement(RecentWorkItemIcon, {
    src: iconUrl,
    alt: ""
  }), /*#__PURE__*/React.createElement(RecentWorkItemBody, null, /*#__PURE__*/React.createElement(RecentWorkItemTitle, null, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, title)), /*#__PURE__*/React.createElement(RecentWorkItemByline, null, /*#__PURE__*/React.createElement(RecentWorkItemContainer, null, container), /*#__PURE__*/React.createElement(RecentWorkItemDescription, null, description)))));
};